import React from 'react'

const Null: React.FunctionComponent = () => null;

export default Null;
